module.exports = __webpack_public_path__ + "img/create-list.852b6e50.svg";